module.exports = __webpack_public_path__ + "static/img/AkkuratPro-Regular.85acb92.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AkkuratPro-Regular.svg
// module id = m6y1
// module chunks = 1